// This project uses Zod v4; @a2ui/web_core uses Zod v3 internally.
// GenericBinder's scrapeSchemaBehavior reads _def.typeName (Zod v3 API).
// A v4 z.object() has _def.type = "object" instead, so the binder falls
// back to STATIC and passes binding objects straight through to components.
// This helper creates a minimal Zod v3-compatible object-schema shim.
// Use it as the outer wrapper; the property schemas (DynamicStringSchema etc.)
// must still come from @a2ui/web_core/v0_9 (they are already Zod v3).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function defineA2uiComponentSchema(shape: Record<string, any>) {
  return {
    _def: {
      typeName: 'ZodObject' as const,
      shape: () => shape,
    },
  };
}
